import useDefaultInputStyles from "../../hooks/useDefaultInputStyles";
import MultiSelectMenu from "./MultiSelectMenu";
import { useState, useEffect, useRef } from "react";
import { registerMenuCloser } from "../../services/menuManager";

//usesInForm = true если мультиселект используется в форме (решение конфликта сабмитов)
function MultiSelect({
  radio = false,
  className,
  title,
  hasSearch = true,
  items,
  name,
  setValue,
  getValues,
  watch,
  classes = {},
  isAddMoreOptions = false,
  noArrow = false,
  usesInForm = false,
  disabled = false, // новый проп
  shouldSubmitOnReset = true,
  ...props
}) {
  const styledProps = useDefaultInputStyles({
    ...props,
    className: classes.multiSelect_menu_wrapper
  });

  const [isOpen, setIsOpen] = useState(false);
  let [closeState, setCloseState] = useState(true);

  const idRef = useRef(Math.random().toString(36).slice(2));

  useEffect(() => {
    function handleCloseAll(e) {
      if (e.detail !== idRef.current) {
        setCloseState(true);
      }
    }
    window.addEventListener("multiselect-close-all", handleCloseAll);
    return () => window.removeEventListener("multiselect-close-all", handleCloseAll);
  }, []);

  // Закрываем меню при включении disabled
  useEffect(() => {
    if (disabled) {
      setCloseState(true);
    }
  }, [disabled]);

  function handleClick(evt) {
    if (disabled) return; // блокируем взаимодействие
    registerMenuCloser(() => setCloseState(true));
    setCloseState((curent) => !curent);
  }

  return (
    <div style={disabled ? { opacity: 0.6, pointerEvents: "none" } : undefined}>
      <div className={`${className} `} onClick={handleClick}>
        {isAddMoreOptions ? (() => {
          const selected = getValues?.(name) || {};
          const selectedItems = items.filter(item => selected[item.id || item.slug]);
          if (selectedItems.length > 0) {
            return (
              <div className={`${classes.select_wrapper}`}>
                <div className="select_placeholder_upper-placeholder">
                  {title}
                </div>
                <div className="select_values_items">
                  {selectedItems.map((item, index) => (
                    <div className="select_values_item" key={item.id || item.slug || index}>
                      <p className="select_values_item_title">
                        {item.name}
                      </p>
                      <div
                        className="select_values_item_delete"
                        onClick={e => {
                          e.stopPropagation();
                          if (disabled) return; // блокируем удаление
                          setValue(name, {
                            ...getValues(name),
                            [item.id || item.slug]: false,
                          }, { shouldDirty: true });
                        }}
                      ></div>
                    </div>
                  ))}
                </div>
              </div>
            );
          }
          return title;
        })() : title}
        {!noArrow && (
          <div
            className={` 
              ${isAddMoreOptions ?
                `select_plus` :
                `select_arrow ${closeState ? "closed" : "opened"}`} 
              ${props.classes}`}
            onClick={() => {
              if (isAddMoreOptions) {
                handleClick()
                setCloseState(!closeState)
              }
            }}
          ></div>
        )}

      </div>
      <MultiSelectMenu
        radio={radio}
        closeState={closeState}
        setCloseState={setCloseState}
        hasSearch={hasSearch}
        title={title}
        name={name}
        items={items}
        setValue={setValue}
        getValues={getValues}
        watch={watch}
        usesInForm={usesInForm}
        disabled={disabled} // передаём disabled в меню, чтобы там тоже заблокировать взаимодействие
        {...styledProps}
        shouldSubmitOnReset = {shouldSubmitOnReset}
      ></MultiSelectMenu>
    </div>
  );
}

export default MultiSelect;